import React from 'react';
import PropTypes from 'prop-types';
import { icons, MoreMenu } from 'smartsuite-ui';
import { useLabelContext } from '../shared/hooks/labelContext';

export default function EditRemoveMenu(props) {
    const { exportLabels, translationLabels } = useLabelContext();

    const menuItems = [
        {
            description: translationLabels.edit,
            onClick: props.editPanel,
            sortOrder: 0,
            iconClass: icons.edit,
        },
        {
            description: translationLabels.delete,
            onClick: props.deletePanel,
            sortOrder: 1,
            iconClass: icons.trash,
        },
    ];

    if (props.showDownload) {
        menuItems.push({
            description: `${exportLabels.downloadTable} (CSV)`,
            onClick: props.onDownload,
            sortOrder: 2,
            iconClass: icons.download,
        });
    }

    return (
        <div className="edit-remove-menu">
            <MoreMenu menuItems={menuItems} />
        </div>
    );
}

EditRemoveMenu.propTypes = {
    deletePanel: PropTypes.func.isRequired,
    editPanel: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,
    showDownload: PropTypes.bool.isRequired,
};
